import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { getCurrentOS } from 'utils';
import { PageHeader } from 'components';

import { tabs } from '../schemas';

import Windows from './Windows';
import Linux from './Linux';
import MacOS from './MacOS';
import Mobile from './Mobile';

function Installer() {
  const currentOS = getCurrentOS();
  const components = { Windows, Linux, MacOS, Mobile };
  const navigate = useNavigate();
  return (
    <div>
      <PageHeader
        goBack={() => navigate('/hardware/installer')}
        title="Installer App"
      />
      <div className="my-3 jumbotron">
        Installer is an application that is running locally on your machine and
        communicates with the POS Brazil. Once you have installed it, it will
        listen for any dependencies that the POS would need and install them
        automatically for you. Below you can find a detailed information about
        how to install the application on different platforms.
      </div>
      <Tabs defaultActiveKey={currentOS} id="uncontrolled-tab-example">
        {tabs.map((tab) => (
          <Tab key={tab.key} eventKey={tab.key} title={tab.title}>
            {components[tab.title] && components[tab.title]()}
          </Tab>
        ))}
      </Tabs>
    </div>
  );
}

export default Installer;
